module.exports = __webpack_public_path__ + "static/new-jam-page-ab4c8ea812173eed56a5f72dbd784025.jpg";